import type {
  TPassengerFormData,
  TFlightDetails,
  TContactsDetails,
  TPassengerFormDataV2
} from '@/components/forms/ask-question/flows/types'
import { defineStore, skipHydrate } from 'pinia'
import { useSessionStorage, StorageSerializers } from '@vueuse/core'
import { SContactsDetails, SFlightDetails, SPassengerDetails } from '@/schemas/forms/Forms.schema'

export const useAQFV1 = defineStore('AQFV1', () => {
  const passengerDetails = useSessionStorage<(TPassengerFormData | TPassengerFormDataV2)[]>('passengerDetails', [])
  const flightDetails = useSessionStorage<TFlightDetails[]>('flightDetails', [])
  const contactsDetails = useSessionStorage<TContactsDetails | null>('contactsDetails', null, {
    serializer: StorageSerializers.object
  })
  const pnr = useSessionStorage<string | null>('pnr', null)

  function getAllFormsData() {
    return {
      passengerDetails: passengerDetails.value,
      flightDetails: flightDetails.value,
      contactsDetails: contactsDetails.value
    }
  }

  function resetStates() {
    passengerDetails.value = [generateObjectFromSchema(SPassengerDetails)]
    flightDetails.value = [generateObjectFromSchema(SFlightDetails)]
    contactsDetails.value = generateObjectFromSchema(SContactsDetails)
    pnr.value = null
  }

  // Initialize states if they are empty
  function initStates() {
    passengerDetails.value = passengerDetails.value.length
      ? passengerDetails.value
      : [generateObjectFromSchema(SPassengerDetails)]
    flightDetails.value = flightDetails.value.length ? flightDetails.value : [generateObjectFromSchema(SFlightDetails)]
    contactsDetails.value = contactsDetails.value ? contactsDetails.value : generateObjectFromSchema(SContactsDetails)
  }

  return {
    passengerDetails: skipHydrate(passengerDetails),
    flightDetails: skipHydrate(flightDetails),
    contactsDetails: skipHydrate(contactsDetails),
    getAllFormsData: skipHydrate(getAllFormsData),
    pnr: skipHydrate(pnr),
    resetStates,
    initStates
  }
})
